/**
 * Comprehensive Phrases Data - Actions
 * 动作短语集合
 *
 * 包含常用的动词短语和动作表达，约40个短语
 */

import { Phrase } from './phrases-types';

export const actionPhrases: Phrase[] = [
  // ==================== 日常动作 Daily Actions ====================

  // 起居相关
  {
    id: 'action_get_up',
    phrase: 'get up',
    phonetic: '/ɡet ʌp/',
    meaning: '起床',
    usageScenario: '描述早上起床的动作',
    example: 'I get up at 7 o\'clock every day.',
    exampleTranslation: '我每天7点起床。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_go_to_bed',
    phrase: 'go to bed',
    phonetic: '/ɡoʊ tuː bed/',
    meaning: '去睡觉',
    usageScenario: '描述晚上去睡觉的动作',
    example: 'I go to bed at 9 o\'clock.',
    exampleTranslation: '我9点去睡觉。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_wake_up',
    phrase: 'wake up',
    phonetic: '/weɪk ʌp/',
    meaning: '醒来',
    usageScenario: '描述从睡眠中醒来的动作',
    example: 'I wake up early in the morning.',
    exampleTranslation: '我早上醒得很早。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_go_to_sleep',
    phrase: 'go to sleep',
    phonetic: '/ɡoʊ tuː sliːp/',
    meaning: '入睡',
    usageScenario: '描述开始睡觉的动作',
    example: 'I go to sleep at 10 p.m.',
    exampleTranslation: '我晚上10点入睡。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 饮食相关
  {
    id: 'action_have_breakfast',
    phrase: 'have breakfast',
    phonetic: '/hæv ˈbrekfəst/',
    meaning: '吃早餐',
    usageScenario: '描述吃早餐的动作',
    example: 'I have breakfast at 7:30.',
    exampleTranslation: '我7:30吃早餐。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_have_lunch',
    phrase: 'have lunch',
    phonetic: '/hæv lʌntʃ/',
    meaning: '吃午餐',
    usageScenario: '描述吃午餐的动作',
    example: 'We have lunch at school.',
    exampleTranslation: '我们在学校吃午餐。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_have_dinner',
    phrase: 'have dinner',
    phonetic: '/hæv ˈdɪnər/',
    meaning: '吃晚餐',
    usageScenario: '描述吃晚餐的动作',
    example: 'We have dinner at 6 o\'clock.',
    exampleTranslation: '我们6点吃晚餐。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_eat_out',
    phrase: 'eat out',
    phonetic: '/iːt aʊt/',
    meaning: '外出就餐',
    usageScenario: '描述去餐厅或外面吃饭',
    example: "Let's eat out tonight!",
    exampleTranslation: '我们今晚出去吃吧！',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'action_make_breakfast',
    phrase: 'make breakfast',
    phonetic: '/meɪk ˈbrekfəst/',
    meaning: '做早餐',
    usageScenario: '描述制作早餐的动作',
    example: 'My mom makes breakfast for us.',
    exampleTranslation: '我妈妈为我们做早餐。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 学习相关
  {
    id: 'action_do_homework',
    phrase: 'do homework',
    phonetic: '/duː ˈhoʊmwɜːrk/',
    meaning: '做作业',
    usageScenario: '描述做家庭作业的动作',
    example: 'I do homework after school.',
    exampleTranslation: '我放学后做作业。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_study_hard',
    phrase: 'study hard',
    phonetic: '/ˈstʌdi hɑːrd/',
    meaning: '努力学习',
    usageScenario: '描述认真学习的状态',
    example: 'I study hard every day.',
    exampleTranslation: '我每天都努力学习。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_work_hard',
    phrase: 'work hard',
    phonetic: '/wɜːrk hɑːrd/',
    meaning: '努力工作',
    usageScenario: '描述努力工作或努力做某事',
    example: 'My parents work hard.',
    exampleTranslation: '我的父母工作很努力。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_read_books',
    phrase: 'read books',
    phonetic: '/riːd bʊks/',
    meaning: '读书',
    usageScenario: '描述阅读书籍的动作',
    example: 'I like to read books in the library.',
    exampleTranslation: '我喜欢在图书馆读书。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_read_aloud',
    phrase: 'read aloud',
    phonetic: '/riːd əˈlaʊd/',
    meaning: '大声朗读',
    usageScenario: '描述大声读出来的动作',
    example: 'Please read aloud the text.',
    exampleTranslation: '请大声朗读课文。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'action_write_down',
    phrase: 'write down',
    phonetic: '/raɪt daʊn/',
    meaning: '写下',
    usageScenario: '描述记录或写下来的动作',
    example: 'Write down your name, please.',
    exampleTranslation: '请写下你的名字。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 出行相关
  {
    id: 'action_go_to_school',
    phrase: 'go to school',
    phonetic: '/ɡoʊ tuː skuːl/',
    meaning: '去学校',
    usageScenario: '描述去学校上学的动作',
    example: 'I go to school by bus.',
    exampleTranslation: '我坐公交车去学校。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_go_home',
    phrase: 'go home',
    phonetic: '/ɡoʊ hoʊm/',
    meaning: '回家',
    usageScenario: '描述回家的动作，注意home前不加to',
    example: 'I go home after school.',
    exampleTranslation: '我放学后回家。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_go_out',
    phrase: 'go out',
    phonetic: '/ɡoʊ aʊt/',
    meaning: '出去',
    usageScenario: '描述外出或出去的动作',
    example: "Let's go out for a walk.",
    exampleTranslation: '我们出去散步吧。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_come_in',
    phrase: 'come in',
    phonetic: '/kʌm ɪn/',
    meaning: '进来',
    usageScenario: '邀请或允许某人进入房间',
    example: 'Come in, please.',
    exampleTranslation: '请进。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_come_back',
    phrase: 'come back',
    phonetic: '/kʌm bæk/',
    meaning: '回来',
    usageScenario: '描述返回或回来的动作',
    example: "I'll come back soon.",
    exampleTranslation: '我很快就回来。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_take_a_bus',
    phrase: 'take a bus',
    phonetic: '/teɪk ə bʌs/',
    meaning: '坐公交车',
    usageScenario: '描述乘坐公交车的交通方式',
    example: 'I take a bus to school.',
    exampleTranslation: '我坐公交车去学校。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_take_a_taxi',
    phrase: 'take a taxi',
    phonetic: '/teɪk ə ˈtæksi/',
    meaning: '打车',
    usageScenario: '描述乘坐出租车的交通方式',
    example: "Let's take a taxi. It's faster.",
    exampleTranslation: '我们打车吧。这样更快。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'action_walk_to',
    phrase: 'walk to',
    phonetic: '/wɔːk tuː/',
    meaning: '步行去……',
    usageScenario: '描述走路的交通方式',
    example: 'I walk to school every day.',
    exampleTranslation: '我每天走路去学校。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 娱乐活动
  {
    id: 'action_watch_tv',
    phrase: 'watch TV',
    phonetic: '/wɒtʃ tiː ˈviː/',
    meaning: '看电视',
    usageScenario: '描述观看电视节目的动作',
    example: 'I watch TV in the evening.',
    exampleTranslation: '我晚上看电视。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_play_games',
    phrase: 'play games',
    phonetic: '/pleɪ ɡeɪmz/',
    meaning: '玩游戏',
    usageScenario: '描述玩游戏（电子游戏或体育游戏）',
    example: 'I play games on Sunday.',
    exampleTranslation: '我星期日玩游戏。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_play_football',
    phrase: 'play football',
    phonetic: '/pleɪ ˈfʊtbɔːl/',
    meaning: '踢足球',
    usageScenario: '描述踢足球的运动动作',
    example: 'I play football with my friends.',
    exampleTranslation: '我和朋友们踢足球。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_play_basketball',
    phrase: 'play basketball',
    phonetic: '/pleɪ ˈbæskɪtbɔːl/',
    meaning: '打篮球',
    usageScenario: '描述打篮球的运动动作',
    example: "Let's play basketball!",
    exampleTranslation: '让我们打篮球吧！',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_listen_to_music',
    phrase: 'listen to music',
    phonetic: '/ˈlɪsn tuː ˈmjuːzɪk/',
    meaning: '听音乐',
    usageScenario: '描述听音乐的休闲活动',
    example: 'I like to listen to music.',
    exampleTranslation: '我喜欢听音乐。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 日常操作
  {
    id: 'action_open_the_door',
    phrase: 'open the door',
    phonetic: '/ˈoʊpən ðə dɔːr/',
    meaning: '开门',
    usageScenario: '描述打开门的动作',
    example: 'Can you open the door?',
    exampleTranslation: '你能开门吗？',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_close_the_door',
    phrase: 'close the door',
    phonetic: '/kloʊz ðə dɔːr/',
    meaning: '关门',
    usageScenario: '描述关门的动作',
    example: 'Please close the door.',
    exampleTranslation: '请关门。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_turn_on',
    phrase: 'turn on',
    phonetic: '/tɜːrn ɒn/',
    meaning: '打开（电器）',
    usageScenario: '打开电器设备，如灯、电视、电脑等',
    example: 'Please turn on the light.',
    exampleTranslation: '请开灯。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_turn_off',
    phrase: 'turn off',
    phonetic: '/tɜːrn ɒf/',
    meaning: '关闭（电器）',
    usageScenario: '关闭电器设备',
    example: 'Turn off the TV, please.',
    exampleTranslation: '请关掉电视。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_put_on',
    phrase: 'put on',
    phonetic: '/pʊt ɒn/',
    meaning: '穿上',
    usageScenario: '穿上衣服、鞋子、帽子等',
    example: 'Put on your coat. It\'s cold.',
    exampleTranslation: '穿上你的外套。很冷。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_take_off',
    phrase: 'take off',
    phonetic: '/teɪk ɒf/',
    meaning: '脱下',
    usageScenario: '脱下衣服、鞋子、帽子等',
    example: 'Take off your shoes, please.',
    exampleTranslation: '请脱下你的鞋子。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_pick_up',
    phrase: 'pick up',
    phonetic: '/pɪk ʌp/',
    meaning: '捡起',
    usageScenario: '从地上捡起某物',
    example: 'Please pick up your toys.',
    exampleTranslation: '请捡起你的玩具。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'action_look_at',
    phrase: 'look at',
    phonetic: '/lʊk æt/',
    meaning: '看……',
    usageScenario: '描述看某事物的动作',
    example: 'Look at the beautiful bird!',
    exampleTranslation: '看那只美丽的鸟！',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_listen_to',
    phrase: 'listen to',
    phonetic: '/ˈlɪsn tuː/',
    meaning: '听……',
    usageScenario: '描述听某人或某事物的动作',
    example: 'Listen to the teacher, please.',
    exampleTranslation: '请听老师讲。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_hurry_up',
    phrase: 'hurry up!',
    phonetic: '/ˈhɜːri ʌp/',
    meaning: '快点！',
    usageScenario: '催促别人加快速度',
    example: 'Hurry up! We are late!',
    exampleTranslation: '快点！我们迟到了！',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_sit_down',
    phrase: 'sit down',
    phonetic: '/sɪt daʊn/',
    meaning: '坐下',
    usageScenario: '描述坐下的动作',
    example: 'Please sit down.',
    exampleTranslation: '请坐下。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'action_stand_up',
    phrase: 'stand up',
    phonetic: '/stænd ʌp/',
    meaning: '站起来',
    usageScenario: '描述站起来的动作',
    example: 'Please stand up.',
    exampleTranslation: '请站起来。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
];